import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Menu } from './menu.service';

@Injectable({
  providedIn: 'root'
})
export class MenuStoreService {

  private readonly keyPrefix =
    'auth.navigationMenus.';

  private readonly menusSubject =
    new BehaviorSubject<Menu[]>([]);

  readonly menus$ =
    this.menusSubject.asObservable();

  get snapshot(): Menu[] {
    return this.menusSubject.value;
  }

  restore(
    userId: string
  ): Menu[] | null {
    if (!userId) {
      return null;
    }

    try {
      const storedValue =
        sessionStorage.getItem(
          this.getKey(userId)
        );

      if (!storedValue) {
        return null;
      }

      const parsedValue =
        JSON.parse(storedValue);

      if (!Array.isArray(parsedValue)) {
        this.remove(userId);
        return null;
      }

      const menus =
        parsedValue as Menu[];

      this.menusSubject.next(menus);

      return menus;

    } catch {
      this.remove(userId);
      return null;
    }
  }

  set(
    userId: string,
    menus: Menu[]
  ): void {
    if (!userId) {
      return;
    }

    const safeMenus =
      Array.isArray(menus)
        ? menus
        : [];

    sessionStorage.setItem(
      this.getKey(userId),
      JSON.stringify(safeMenus)
    );

    this.menusSubject.next(
      safeMenus
    );
  }

  remove(userId: string): void {
    if (userId) {
      sessionStorage.removeItem(
        this.getKey(userId)
      );
    }

    this.menusSubject.next([]);
  }

  clear(): void {
    Object.keys(sessionStorage)
      .filter(key =>
        key.startsWith(
          this.keyPrefix
        )
      )
      .forEach(key =>
        sessionStorage.removeItem(key)
      );

    this.menusSubject.next([]);
  }

  private getKey(
    userId: string
  ): string {
    return `${this.keyPrefix}${userId}`;
  }
}